import { Hub } from "aws-amplify/utils";

import type { HubCapsule } from "aws-amplify/utils";

/**
 * The events Amplify v6 emits on its `auth` Hub channel. The SDK exports no
 * name for this union, so it is spelled out here; `authHub.test.ts` fails
 * typecheck if the two ever differ, so a name the SDK dropped (v5's `signIn`,
 * say) can't linger here and silently never match.
 */
export type AuthHubEvent =
  | "customOAuthState"
  | "signInWithRedirect"
  | "signInWithRedirect_failure"
  | "signedIn"
  | "signedOut"
  | "tokenRefresh"
  | "tokenRefresh_failure";

/** What Amplify hands a listener on its `auth` Hub channel. */
export type AuthHubCapsule = HubCapsule<
  "auth",
  { event: AuthHubEvent; data?: unknown }
>;

/**
 * Subscribes to Amplify's `auth` channel; returns the unsubscribe. The one
 * place the console touches the Hub, so tests mock this module rather than
 * Amplify's.
 */
export function listenToAuth(
  handler: (capsule: AuthHubCapsule) => void,
): () => void {
  return Hub.listen("auth", handler);
}
